import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { useEffect } from 'react';
import Login from './pages/login.jsx';
import Home from './pages/home.jsx';
import heartCursor from './assets/pics/heart-cursor.png';
import ProtectedRoute from './components/ProtectedRoute.js';

function App() {
  useEffect(() => {
    document.body.style.cursor = `url(${heartCursor}) 16 16, auto`;
  }, []);

  return (
    <Router>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/home" element={<ProtectedRoute><Home /></ProtectedRoute>} />
      </Routes>
    </Router>
  );
}

export default App;